import type { ReactNode } from "react";
import { useParams } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import { isUrlPrefixLanguage } from "@/constants/urlLangPrefix";

/**
 * Only `de` and `fr` are valid as the `/:lang` segment. Anything else renders
 * the 404 page (avoids duplicate “home” URLs like `/en` or `/foo` for SEO).
 */
export function RequireLocalizedLang({ children }: { children: ReactNode }) {
  const { lang } = useParams<{ lang: string }>();

  if (!isUrlPrefixLanguage(lang)) {
    return <NotFound />;
  }

  return <>{children}</>;
}
